var map = {
	"./accept-open-notification-en.png": 80553,
	"./accept-open-notification-es.png": 84444,
	"./add-notification-en.png": 43105,
	"./add-notification-es.png": 36292,
	"./alert-create-before-en.png": 91717,
	"./alert-create-before-es.png": 14912,
	"./alert-create-detail-en.png": 64251,
	"./alert-create-detail-es.png": 41070,
	"./alert-create-history-en.png": 78224,
	"./alert-create-history-es.png": 25557,
	"./alert-modify-en.png": 4443,
	"./alert-modify-es.png": 2830,
	"./attach-files-en.png": 51099,
	"./attach-files-es.png": 33134,
	"./change-status-dialog-en.png": 93092,
	"./change-status-dialog-es.png": 91457,
	"./change-status-history-en.png": 33202,
	"./change-status-history-es.png": 17111,
	"./massive-actions/button-en.png": 33633,
	"./massive-actions/button-es.png": 35268,
	"./massive-actions/change-state-en.png": 53161,
	"./massive-actions/change-state-es.png": 22876,
	"./massive-actions/massive-actions-en.png": 7089,
	"./massive-actions/open-notification-en.png": 26285,
	"./massive-actions/open-notification-es.png": 41720,
	"./massive-actions/options-en.png": 78515,
	"./massive-actions/options-es.png": 79670,
	"./massive-actions/selected-items-en.png": 69365,
	"./massive-actions/selected-items-es.png": 24592,
	"./massive-actions/set-alert-en.png": 30618,
	"./massive-actions/set-alert-es.png": 1487,
	"./massive-actions/set-observation-en.png": 95694,
	"./massive-actions/set-observation-es.png": 18875,
	"./massive-actions/set-responsible-en.png": 93404,
	"./massive-actions/set-responsible-es.png": 23689,
	"./metadata-en.png": 42677,
	"./metadata-es.png": 11696,
	"./metadata-expanded-en.png": 4843,
	"./metadata-expanded-es.png": 33694,
	"./notification-detail-en.png": 85145,
	"./notification-detail-es.png": 31276,
	"./notification-list-detail-en.png": 95572,
	"./notification-list-detail-es.png": 57425,
	"./notification-list-detail-full-en.png": 32244,
	"./notification-list-detail-full-es.png": 97649,
	"./notification-list-detail-operator-en.png": 78977,
	"./notification-list-detail-operator-es.png": 72164,
	"./opened-notification-en.png": 58809,
	"./opened-notification-es.png": 61420,
	"./pic-add-extra-doc-en.png": 33408,
	"./pic-add-extra-doc-es.png": 10213,
	"./pic-added-extra-doc-en.png": 98645,
	"./pic-added-extra-doc-es.png": 19696,
	"./pic-delete-extra-file-en.png": 40734,
	"./pic-delete-extra-file-es.png": 35179,
	"./pic-history-delete-en.png": 99015,
	"./pic-history-delete-es.png": 27170,
	"./pic-notif-detail-extra-closeup-en.png": 70780,
	"./pic-notif-detail-extra-closeup-es.png": 66889,
	"./pic-notif-detail-extra-en.png": 99316,
	"./pic-notif-detail-extra-es.png": 7249,
	"./pic-notif-detail-observation-en.png": 66040,
	"./pic-notif-detail-observation-es.png": 3629,
	"./pic-notif-detail-observation-history-en.png": 6237,
	"./pic-notif-detail-observation-history-es.png": 41192,
	"./pic-update-notifications-en.png": 11499,
	"./pic-update-notifications-es.png": 56702,
	"./responsability-assigned-en.png": 77507,
	"./responsability-assigned-es.png": 8134,
	"./responsability-empty-en.png": 96286,
	"./responsability-empty-es.png": 74379,
	"./responsability-history-en.png": 60027,
	"./responsability-history-es.png": 58414,
	"./responsability-list-en.png": 63971,
	"./responsability-list-es.png": 10950,
	"./share-notification-via-email-multiple-en.png": 1426,
	"./share-notification-via-email-multiple-es.png": 94391,
	"./share-notification-via-email-multiple-history-en.png": 9491,
	"./share-notification-via-email-multiple-history-es.png": 84470,
	"./share-notification-via-email-single-en.png": 56490,
	"./share-notification-via-email-single-es.png": 90943,
	"./share-notification-via-email-single-history-en.png": 4987,
	"./share-notification-via-email-single-history-es.png": 87022,
	"./share-notification-via-link-en.png": 5269,
	"./share-notification-via-link-es.png": 60496,
	"./superior-menu-en.png": 35283,
	"./superior-menu-es.png": 93910,
	"./upload-files-button-en.png": 63708,
	"./upload-files-button-es.png": 44969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7821;